export default {
  title: '數據報表',
  salesReport: '銷售報表',
};
